import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  0% {\n    stroke-dashoffset: ",
        ";\n    transform: rotate(0deg);\n  } 50% {\n    stroke-dashoffset: ",
        ";\n    transform: rotate(720deg);\n  } 100% {\n    stroke-dashoffset: ",
        ";\n    transform: rotate(1080deg);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n      ",
        "\n      circle {\n        fill: transparent;\n        stroke: currentColor;\n        stroke-width: 2;\n        stroke-linecap: round;\n        transform-origin: center;\n        animation: ",
        " 2s linear infinite;\n        stroke-dasharray: ",
        ";\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  svg {\n    x: 0px;\n    y: 0px;\n\n    ",
        "\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  visibility: hidden;\n  display: inherit;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  display: inline-block;\n  padding: 0;\n  transition: background ",
        ",\n    border-color ",
        ";\n  font-family: ",
        ";\n  text-decoration: none;\n  appearance: none;\n  background-color: transparent;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  white-space: nowrap;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n  ",
        "\n\n  ",
        " {\n    position: relative;\n\n    ",
        "\n  }\n\n  ",
        " {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled, { css, keyframes } from "styled-components";
import convertLayoutProps from "../../utils/convertLayoutProps";
import FocusTrap from "../focus-trap/FocusTrap";
import Box from "../layout/Box";
import { useTemplateOpener } from "../template-opener/TemplateOpener";
import getArrowDirectionCSS from "./helpers/getArrowDirectionCSS";
var SpinnerBase = function(param) {
    var _$size = param.$size, $size = _$size === void 0 ? 24 : _$size, _$gutter = param.$gutter, $gutter = _$gutter === void 0 ? 4 : _$gutter, className = param.className;
    return /*#__PURE__*/ _jsx(Box, {
        className: className,
        $styles: {
            width: $size,
            height: $size
        },
        children: /*#__PURE__*/ _jsxs("svg", {
            viewBox: "0 0 ".concat($size, " ").concat($size),
            children: [
                /*#__PURE__*/ _jsx("title", {
                    children: "Loading..."
                }),
                /*#__PURE__*/ _jsx("circle", {
                    cx: $size / 2,
                    cy: $size / 2,
                    r: $size / 2 - $gutter / 2
                })
            ]
        })
    });
};
var spinner = function(size) {
    return keyframes(_templateObject(), 0.66 * size, 3.14 * size, 0.66 * size);
};
var RotatingSpinner = styled(SpinnerBase).withConfig({
    componentId: "sc-6bd17829-0"
})(_templateObject2(), function(param) {
    var theme = param.theme, _$size = param.$size, $size = _$size === void 0 ? 24 : _$size;
    return css(_templateObject1(), theme.normalizeStyles({
        width: $size,
        height: $size
    }), spinner($size), 3.14 * $size);
});
var Hidden = styled.div.withConfig({
    componentId: "sc-6bd17829-1"
})(_templateObject3());
//! missing rel, event_class, target from twig
var ButtonElement = /*#__PURE__*/ React.forwardRef(function(_param, ref) {
    var _isLoading = _param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, children = _param.children, href = _param.href, onClick = _param.onClick, templateId = _param.templateId, className = _param.className, disabled = _param.disabled, $buttonType = _param.$buttonType, props = _object_without_properties(_param, [
        "isLoading",
        "children",
        "href",
        "onClick",
        "templateId",
        "className",
        "disabled",
        "$buttonType"
    ]);
    var setTemplateId = useTemplateOpener().setTemplateId;
    if (isLoading) {
        return /*#__PURE__*/ _jsx("button", _object_spread_props(_object_spread({
            className: className,
            disabled: true,
            ref: ref
        }, props), {
            children: /*#__PURE__*/ _jsxs(FocusTrap, {
                children: [
                    /*#__PURE__*/ _jsx(RotatingSpinner, {}),
                    /*#__PURE__*/ _jsx(Hidden, {
                        children: children
                    })
                ]
            })
        }));
    }
    if (href) {
        return /*#__PURE__*/ _jsx("a", _object_spread_props(_object_spread({
            onClick: function(e) {
                if (disabled) {
                    e.preventDefault();
                    return;
                }
                if (templateId) {
                    e.preventDefault();
                    setTemplateId(templateId);
                }
                if (onClick) {
                    onClick(e);
                }
            },
            ref: ref,
            href: href,
            className: "".concat(className, " js__event-link")
        }, props), {
            children: /*#__PURE__*/ _jsx(FocusTrap, {
                children: children
            })
        }));
    }
    return /*#__PURE__*/ _jsx("button", _object_spread_props(_object_spread({
        onClick: function(e) {
            if (templateId) {
                e.preventDefault();
                setTemplateId(templateId);
            }
            if (onClick) {
                onClick(e);
            }
        },
        ref: ref,
        className: className,
        disabled: disabled
    }, props), {
        children: /*#__PURE__*/ _jsx(FocusTrap, {
            children: children
        })
    }));
});
ButtonElement.displayName = "ButtonElement";
var ButtonBase = styled(ButtonElement).withConfig({
    componentId: "sc-6bd17829-2"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.animation.transitionDuration;
}, function(param) {
    var theme = param.theme;
    return theme.animation.transitionDuration;
}, function(param) {
    var theme = param.theme;
    return theme.fonts.formular;
});
var Button = styled(ButtonBase).withConfig({
    componentId: "sc-6bd17829-3"
})(_templateObject5(), function(param) {
    var theme = param.theme, $buttonType = param.$buttonType;
    return $buttonType && theme.expandVariants($buttonType, theme.buttons.variants);
}, function(_param) {
    var theme = _param.theme, $styles = _param.$styles, isLoading = _param.isLoading, $withArrow = _param.$withArrow, $buttonType = _param.$buttonType, $size = _param.$size, props = _object_without_properties(_param, [
        "theme",
        "$styles",
        "isLoading",
        "$withArrow",
        "$buttonType",
        "$size"
    ]);
    var buttonSize = $size ? theme.buttons.sizes[$size] : {};
    return theme.normalizeStyles(_object_spread({}, buttonSize, convertLayoutProps(props), $styles));
}, FocusTrap, function(param) {
    var theme = param.theme, $size = param.$size, $withArrow = param.$withArrow;
    var buttonSpacing = {};
    if ($size) {
        buttonSpacing = $withArrow ? theme.buttons.withArrowSpacing[$size] : theme.buttons.spacing[$size];
    }
    return theme.normalizeStyles(buttonSpacing);
}, RotatingSpinner, getArrowDirectionCSS);
export default Button;
